























































































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  collectionApi,
  defaultOrder,
  defaultSimpleBibliographyReal,
  ErrorMessage,
  Order,
  orderApi,
  ShelfTypeConversionInfo,
  SimpleBibliographyReal
} from '@/api'
import {
  alertStore,
  appStore,
  modalOrderEditStore,
  modalErrorStore,
  systemParameterStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import {
  defaultInputEditAcceptedAndBudgetItem,
  defaultInputEditBasicItem,
  defaultInputEditWhereAboutItem,
  InputEditAcceptedAndBudgetItem,
  InputEditBasicItem,
  InputEditWhereAboutItem
} from '@/components/templates/collection-edit-order-collection/index.vue'
import {
  defaultInputEditNoteItem,
  InputEditNoteItem
} from '@/components/templates/collection-edit-order-lend-and-other'
import CollectionEditOrderCollectionBasicInfo from '@/components/templates/collection-edit-order-collection/CollectionEditOrderCollectionBasicInfo.vue'
import CollectionEditOrderCollectionWhereAboutInfo from '@/components/templates/collection-edit-order-collection/CollectionEditOrderCollectionWhereAboutInfo.vue'
import CollectionEditOrderCollectionAcceptedAndBudgetInfo from '@/components/templates/collection-edit-order-collection/CollectionEditOrderCollectionAcceptedAndBudgetInfo.vue'
import CollectionEditOrderLendAndOtherNote from '@/components/templates/collection-edit-order-lend-and-other/CollectionEditOrderLendAndOtherNote.vue'
import { CODE_KEY } from '@/config'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  AlertCodeALC00002,
  AlertCodeALC00007,
  AlertCodeCLT00042,
  AlertCodeCLT00050,
  OrderStatus,
  SearchType
} from '@/types'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'

export interface InputEditItem {
  basic: InputEditBasicItem
  whereAbout: InputEditWhereAboutItem
  acceptedAndBudget: InputEditAcceptedAndBudgetItem
  note: InputEditNoteItem
}

export const defaultInputEditItem = (): InputEditItem => ({
  basic: defaultInputEditBasicItem(),
  whereAbout: defaultInputEditWhereAboutItem(),
  acceptedAndBudget: defaultInputEditAcceptedAndBudgetItem(),
  note: defaultInputEditNoteItem()
})

@Component({
  components: {
    BibliographyRealInfoMagazine,
    BibliographyRealInfoSimple,
    CollectionEditOrderLendAndOtherNote,
    CollectionEditOrderCollectionAcceptedAndBudgetInfo,
    CollectionEditOrderCollectionWhereAboutInfo,
    CollectionEditOrderCollectionBasicInfo,
    ModalFooter
  }
})
export default class ModalOrderEdit extends ComponentVue {
  activeTab: number = 1

  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  editItem: InputEditItem = defaultInputEditItem()

  order: Order = defaultOrder()

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get bibliographyRealId(): number {
    return modalOrderEditStore.bibliographyRealId
  }

  get collectionId(): string {
    return modalOrderEditStore.collectionId
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get fontSizeType(): string {
    return appStore._fontSizeType
  }

  get isOpen(): boolean {
    return modalOrderEditStore.isOpen
  }

  get tabStyles(): object {
    if (this.fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': this.fontSize + 'px'
    }
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.COLLECTION_MEMO.KEY])
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY
      ])

      this.getSimpleBibliographyReal()
      this.getOrder()
    }

    this.activeTab = 1
    this.editItem = defaultInputEditItem()
    this.order = defaultOrder()
  }

  convertCamelCaseFromSnakeCase(value: string): string {
    return value.replace(/_./g, str => str.charAt(1).toUpperCase())
  }

  isActiveTab(value: number): boolean {
    return this.activeTab === value
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: modalOrderEditStore.close
    })
  }

  onClickRegistration(): void {
    if (this.editItem.basic.status.input === OrderStatus.Invalid) {
      alertStore.setItem(AlertFactory.create(AlertCodeALC00007, '発注', '削除'))
    } else if (
      this.editItem.whereAbout.sendFlag.input &&
      (this.editItem.whereAbout.mark.input !== this.order.mark ||
        this.editItem.whereAbout.ndc.input !== this.order.ndc ||
        this.editItem.whereAbout.book.input !== this.order.book ||
        this.editItem.whereAbout.sub.input !== this.order.sub)
    ) {
      alertStore.setItem(
        AlertFactory.create(AlertCodeCLT00050, '書店に送信済みデータの更新')
      )
    } else {
      alertStore.setItem(AlertFactory.create(AlertCodeCLT00042, '発注'))
    }

    this.$modalAlert.open({
      modalType: 'WARN',
      onOkClick: this.updateOrder
    })
  }

  setEditItem(): void {
    this.editItem = {
      basic: {
        id: {
          input: String(this.order.id),
          errorMessage: ''
        },
        managementFlag: {
          input: this.order.managementFlag.code,
          errorMessage: ''
        },
        storeType: {
          input: this.order.storeType.code,
          errorMessage: ''
        },
        status: {
          input: this.order.status.code,
          errorMessage: ''
        },
        collectionType: {
          input: this.order.collectionType.code,
          errorMessage: ''
        },
        appendixCode: {
          input: this.order.appendixCode.code,
          errorMessage: ''
        },
        cancelReason: {
          input: this.order.cancelReason.code,
          errorMessage: ''
        },
        handlingType: {
          input: this.order.handlingType.code,
          errorMessage: ''
        }
      },
      whereAbout: {
        buyBranchCode: {
          input: this.order.buyBranchCode.code,
          errorMessage: ''
        },
        departmentCode: {
          input: this.order.departmentCode.code,
          errorMessage: ''
        },
        shelfType: {
          input: this.order.shelfType.code,
          errorMessage: ''
        },
        organizeFlag: {
          input: this.order.organizeFlag,
          errorMessage: ''
        },
        sendFlag: {
          input: this.order.sendFlag,
          errorMessage: ''
        },
        mark: {
          input: this.order.mark,
          errorMessage: ''
        },
        ndc: {
          input: this.order.ndc,
          errorMessage: ''
        },
        book: {
          input: this.order.book,
          errorMessage: ''
        },
        sub: {
          input: this.order.sub,
          errorMessage: ''
        }
      },
      acceptedAndBudget: {
        orderDate: {
          input: this.order.orderDate,
          errorMessage: ''
        },
        tempAcceptDate: {
          input: this.order.tempAcceptDate,
          errorMessage: ''
        },
        acceptType: {
          input: this.order.acceptType.code,
          errorMessage: ''
        },
        orderPrice: {
          input: String(this.order.orderPrice),
          errorMessage: ''
        },
        listPrice: {
          input: String(this.order.listPrice),
          errorMessage: ''
        },
        evaluationPrice: {
          input: String(this.order.evaluationPrice),
          errorMessage: ''
        },
        applicantUserId: {
          input: this.order.applicantUserId,
          errorMessage: ''
        },
        traderCode: {
          input: this.order.traderCode.code,
          errorMessage: ''
        },
        donorCode: {
          input: this.order.donorCode.code,
          errorMessage: ''
        },
        budgetYear: {
          input: String(this.order.budgetYear),
          errorMessage: ''
        },
        budgetBranchCode: {
          input: this.order.budgetBranchCode.code,
          errorMessage: ''
        },
        budgetDepartmentCode: {
          input: this.order.budgetDepartmentCode.code,
          errorMessage: ''
        },
        budgetExpenseCode: {
          input: this.order.budgetExpenseCode.code,
          errorMessage: ''
        },
        equipType: {
          input: this.order.equipType.code,
          errorMessage: ''
        }
      },
      note: {
        workMemo: {
          input: this.order.workMemo,
          code: '',
          time: this.order.workMemoTime,
          place: this.order.workMemoPlaceCode.shortName,
          errorMessage: ''
        },
        displayMemo: {
          input: this.order.displayMemo,
          code: '',
          time: this.order.displayMemoTime,
          place: this.order.displayMemoPlaceCode.shortName,
          errorMessage: ''
        },
        localMemo: {
          input: this.order.localMemo,
          code: '',
          time: this.order.localMemoTime,
          place: this.order.localMemoPlaceCode.shortName,
          errorMessage: ''
        }
      }
    }
  }

  print() {
    const element = document.querySelector('#modal-order-edit')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  setTab(value: number): void {
    this.activeTab = value
  }

  setErrorMessage(alerts: Alert[]): void {
    const array: any[] = Object.entries(this.editItem)
    alerts.some(alert => {
      if (alert.attribute === '') return false

      const convertedPropertyName: string = this.convertCamelCaseFromSnakeCase(
        alert.attribute
      )

      array.some(value => {
        if (value[1][convertedPropertyName]) {
          value[1][convertedPropertyName].errorMessage = alert.message
          return true
        }

        return false
      })
    })
    this.editItem = Object.fromEntries(array) as InputEditItem
  }

  tabClass(value: number): string {
    return this.activeTab === value ? 'active' : ''
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async getOrder(): Promise<void> {
    try {
      this.order = await orderApi.getOrder(this.collectionId)
      this.setEditItem()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      modalOrderEditStore.close()
    }
  }

  async updateOrder(): Promise<void> {
    try {
      await orderApi.updateOrder({
        id: Number(this.editItem.basic.id.input),
        status: this.editItem.basic.status.input,
        cancelReason: this.editItem.basic.cancelReason.input,
        managementFlag: this.editItem.basic.managementFlag.input,
        collectionType: this.editItem.basic.collectionType.input,
        handlingType: this.editItem.basic.handlingType.input,
        storeType: this.editItem.basic.storeType.input,
        appendixCode: this.editItem.basic.appendixCode.input,
        buyBranchCode: this.editItem.whereAbout.buyBranchCode.input,
        departmentCode: this.editItem.whereAbout.departmentCode.input,
        shelfType: this.editItem.whereAbout.shelfType.input,
        mark: this.editItem.whereAbout.mark.input,
        ndc: this.editItem.whereAbout.ndc.input,
        book: this.editItem.whereAbout.book.input,
        sub: this.editItem.whereAbout.sub.input,
        orderDate: this.editItem.acceptedAndBudget.orderDate.input,
        tempAcceptDate: this.editItem.acceptedAndBudget.tempAcceptDate.input,
        acceptType: this.editItem.acceptedAndBudget.acceptType.input,
        listPrice: Number(this.editItem.acceptedAndBudget.listPrice.input),
        evaluationPrice: Number(
          this.editItem.acceptedAndBudget.evaluationPrice.input
        ),
        orderPrice: Number(this.editItem.acceptedAndBudget.orderPrice.input),
        applicantUserId: this.editItem.acceptedAndBudget.applicantUserId.input,
        traderCode: this.editItem.acceptedAndBudget.traderCode.input,
        donorCode: this.editItem.acceptedAndBudget.donorCode.input,
        budgetYear: Number(this.editItem.acceptedAndBudget.budgetYear.input),
        budgetBranchCode: this.editItem.acceptedAndBudget.budgetBranchCode
          .input,
        budgetDepartmentCode: this.editItem.acceptedAndBudget
          .budgetDepartmentCode.input,
        budgetExpenseCode: this.editItem.acceptedAndBudget.budgetExpenseCode
          .input,
        equipType: this.editItem.acceptedAndBudget.equipType.input,
        workMemo: this.editItem.note.workMemo.input,
        displayMemo: this.editItem.note.displayMemo.input,
        localMemo: this.editItem.note.localMemo.input,
        revision: this.order.revision
      })
      modalOrderEditStore.registration()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async convertShelfType(): Promise<void> {
    if (
      this.editItem.basic.collectionType.input === '' &&
      this.editItem.whereAbout.mark.input === '' &&
      this.editItem.whereAbout.ndc.input === '' &&
      this.editItem.whereAbout.book.input === '' &&
      this.editItem.whereAbout.sub.input === ''
    ) {
      return
    }

    this.$eventBus.emit(NAV_LOADING_START)

    try {
      const response: ShelfTypeConversionInfo = await collectionApi.getShelfTypeConversionInfo(
        {
          collectionType: this.editItem.basic.collectionType.input,
          mark: this.editItem.whereAbout.mark.input,
          ndc: this.editItem.whereAbout.ndc.input,
          book: this.editItem.whereAbout.book.input,
          sub: this.editItem.whereAbout.sub.input
        }
      )

      this.editItem.whereAbout.shelfType.input = response.shelfType
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
